import styled from 'styled-components';

// prettier-ignore
export const ReviewContainer = styled.section`
  width: 100%;
  max-width: 820px;

  display: flex;
  flex-direction: column;
  gap: var(--space-l);

  margin: 0 auto;
`;

export const ReviewHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  gap: var(--space-m);

  padding-bottom: var(--space-l);

  border-bottom: 1px solid var(--grey1);

  @media screen and (max-width: 600px) {
    gap: var(--space-s);
    padding-bottom: var(--space-m);
  }
`;

export const ReviewHeaderIcon = styled.div`
  width: 46px;
  height: 46px;
  min-width: 46px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(234, 154, 38, 0.1);
  color: var(--orange4);

  border-radius: 12px;

  svg {
    font-size: 0.95rem;
  }
  @media screen and (max-width: 600px) {
    width: 40px;
    height: 40px;
    min-width: 40px;

    border-radius: 10px;
  }
`;

export const ReviewHeaderContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  > span {
    color: var(--orange4);

    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.07em;
    line-height: 1.2;
    text-transform: uppercase;
  }

  h2 {
    margin: 0;

    color: var(--grey7);

    font-size: clamp(1.35rem, 2vw, 1.7rem);
    font-weight: 800;
    letter-spacing: -0.025em;
    line-height: 1.25;
  }

  p {
    max-width: 620px;

    margin: 0.15rem 0 0;

    color: var(--grey4);

    font-size: 0.85rem;
    line-height: 1.55;
  }

  @media screen and (max-width: 600px) {
    h2 {
      font-size: 1.2rem;
    }

    p {
      font-size: 0.78rem;
    }
  }
`;

export const ReviewIntro = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-s);

  padding: var(--space-m);

  background: rgba(253, 220, 94, 0.08);

  border: 1px solid rgba(253, 220, 94, 0.3);
  border-radius: 12px;

  > svg {
    flex: 0 0 auto;

    margin-top: 0.15rem;

    color: var(--orange4);
    font-size: 0.8rem;
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;

    strong {
      color: var(--grey7);

      font-size: 0.8rem;
      font-weight: 750;
    }

    p {
      max-width: 650px;

      margin: 0;

      color: var(--grey4);

      font-size: 0.75rem;
      line-height: 1.5;
    }
  }
`;

export const ReviewSections = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: var(--space-m);
`;

export const ReviewSection = styled.section`
  width: 100%;

  padding: var(--space-l);

  background: var(--white);

  border: 1px solid var(--grey1);
  border-radius: 14px;

  @media screen and (max-width: 600px) {
    padding: var(--space-m);
  }
`;

export const ReviewSectionHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-m);

  margin-bottom: var(--space-m);
  padding-bottom: var(--space-m);

  border-bottom: 1px solid var(--grey1);
`;

export const ReviewSectionTitle = styled.div`
  min-width: 0;

  display: flex;
  align-items: center;
  gap: var(--space-s);

  > svg {
    flex: 0 0 auto;

    color: var(--orange4);

    font-size: 0.85rem;
  }

  > div {
    min-width: 0;

    display: flex;
    flex-direction: column;
    gap: 0.1rem;

    span {
      color: var(--grey4);

      font-size: 0.62rem;
      font-weight: 750;
      letter-spacing: 0.05em;
      text-transform: uppercase;
    }

    h3 {
      margin: 0;

      color: var(--grey7);

      font-size: 0.95rem;
      font-weight: 800;
      line-height: 1.3;
    }
  }
`;

export const ReviewEditButton = styled.button`
  flex: 0 0 auto;

  padding: 0.4rem 0.7rem;

  background: var(--grey0);
  color: var(--orange4);

  border: 1px solid var(--grey1);
  border-radius: 7px;

  font: inherit;
  font-size: 0.7rem;
  font-weight: 750;

  cursor: pointer;

  transition:
    background 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    background: var(--white);
    border-color: var(--orange4);
  }
`;

export const ReviewDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-m);

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: var(--space-s);
  }
`;

export const ReviewDetail = styled.div`
  min-width: 0;

  display: flex;
  align-items: flex-start;
  gap: var(--space-s);
`;

export const ReviewDetailIcon = styled.div`
  width: 30px;
  height: 30px;
  min-width: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: var(--grey0);
  color: var(--orange4);

  border-radius: 7px;

  svg {
    font-size: 0.7rem;
  }
`;

export const ReviewDetailContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 0.1rem;

  span {
    color: var(--grey4);

    font-size: 0.65rem;
    font-weight: 650;
    line-height: 1.3;
  }

  strong {
    overflow-wrap: anywhere;

    color: var(--grey7);

    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1.45;
  }
`;

export const ReviewEmpty = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-s);

  color: var(--grey4);

  > svg {
    flex: 0 0 auto;

    margin-top: 0.1rem;

    font-size: 0.8rem;
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;

    strong {
      color: var(--grey6);

      font-size: 0.78rem;
      font-weight: 700;
    }

    p {
      margin: 0;

      font-size: 0.73rem;
      line-height: 1.5;
    }
  }
`;

export const ReviewConfirmation = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-s);

  padding: var(--space-m);

  background: rgba(68, 160, 90, 0.06);

  border: 1px solid rgba(68, 160, 90, 0.18);
  border-radius: 12px;
`;

export const ReviewConfirmationIcon = styled.div`
  width: 30px;
  height: 30px;
  min-width: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(68, 160, 90, 0.1);
  color: var(--green5);

  border-radius: 8px;

  svg {
    font-size: 0.7rem;
  }
`;

export const ReviewConfirmationContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;

  strong {
    color: var(--grey7);

    font-size: 0.8rem;
    font-weight: 750;
  }

  p {
    max-width: 650px;

    margin: 0;

    color: var(--grey4);

    font-size: 0.74rem;
    line-height: 1.5;
  }
`;

export const ReviewError = styled.div`
  width: 100%;

  padding: var(--space-m);

  background: rgba(190, 45, 45, 0.06);
  color: var(--errorRed);

  border: 1px solid rgba(190, 45, 45, 0.18);
  border-radius: 10px;

  font-size: 0.78rem;
  font-weight: 650;
  line-height: 1.5;
`;

export const ReviewActions = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-m);

  padding-top: var(--space-m);

  border-top: 1px solid var(--grey1);

  > div,
  > a {
    margin: 0;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column-reverse;
    align-items: stretch;

    > div,
    > a,
    button {
      width: 100%;
    }
  }
`;

export const ReviewBackButton = styled.button`
  padding: var(--space-s) var(--space-m);

  background: transparent;
  color: var(--grey5);

  border: 1px solid var(--grey2);
  border-radius: var(--borderRadiusSmall);

  font: inherit;
  font-size: 0.82rem;
  font-weight: 700;

  cursor: pointer;

  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;

  &:hover:not(:disabled) {
    background: var(--grey0);
    color: var(--grey7);
    border-color: var(--grey3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
